__turbopack_context__.v({
  "brand": "Badge-module-scss-module__KoiirW__brand",
  "default": "Badge-module-scss-module__KoiirW__default",
  "error": "Badge-module-scss-module__KoiirW__error",
  "noBorder": "Badge-module-scss-module__KoiirW__noBorder",
  "root": "Badge-module-scss-module__KoiirW__root",
  "success": "Badge-module-scss-module__KoiirW__success",
  "warning": "Badge-module-scss-module__KoiirW__warning",
});
